/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import Link from '../../../../components/form/elements/link';
import { can, route } from '../../../../services/utils';
import { useParams } from 'react-router-dom';
import Button, {
  ButtonStyling,
} from '../../../../components/form/elements/button';
import { FormComponent } from '../../../../components/form';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';

export const useShowFooter = (editPath: string) => {
  const { farmId, id } = useParams<{
    farmId: string;
    id: string;
  }>();
  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  return useMemo<FormComponent[]>(
    () =>
      [
        can(farmUser, { title: 'update animal_event' })
          ? Link(
              route(editPath, {
                farmId,
                id,
              }),
              'edit',
              true
            )
          : null,
        can(farmUser, { title: 'delete animal_event' })
          ? Button('delete', null, '', null, null, null, ButtonStyling.cancel)
          : null,
      ].filter(Boolean),
    []
  );
};
